export default __webpack_public_path__ + "static/media/tav.118db0a2.jpg";